document.addEventListener('DOMContentLoaded', function () {
  const gridWrapper = document.querySelector('#product-grid-wrapper');
  const productGrid = document.querySelector('#product-grid');
  const loader = document.querySelector('#infinite-scroll-loader');

  let currentPage = parseInt(gridWrapper.dataset.page);
  const totalPages = parseInt(gridWrapper.dataset.pages);
  let isLoading = false;

  const loadNextPage = () => {
    if (isLoading || currentPage >= totalPages) return;

    isLoading = true;
    loader.style.display = 'block';
    currentPage++;

    const url = `${window.location.pathname}?page=${currentPage}&section_id=main-collection-product-grid`;
console.log(`📦 Attempting fetch: ${url}`);


    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // This works only if section_id returns the correct section content
        const newProductGrid = doc.querySelector('#product-grid');

        if (!newProductGrid) {
          console.warn('❌ #product-grid not found in AJAX response. Check section_id or DOM structure.');
          loader.style.display = 'none';
          return;
        }

        const newItems = newProductGrid.querySelectorAll('.grid__item');
        newItems.forEach(item => productGrid.appendChild(item));

        isLoading = false;
        loader.style.display = 'none';
      })
      .catch(error => {
        console.error('❌ Infinite scroll fetch failed:', error);
        isLoading = false;
        loader.style.display = 'none';
      });
  };

  window.addEventListener('scroll', () => {
  console.log('🔄 Scrolling...');
  console.log(`🧪 currentPage: ${currentPage}, totalPages: ${totalPages}, isLoading: ${isLoading}`);
  if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 300)) {
    console.log('✅ Reached bottom, trying to load more...');
    loadNextPage();
    }
  });

});
